import styled from "styled-components";
import { breakpoints } from "styles";

export const KelasLiveCTABlockContainer = styled.section`
  padding: 40px 0 0px 0;
  background: url("/assets/kelas-live/cta-block-left-top.svg") left 0px top 0px/
      200px no-repeat,
    url("/assets/kelas-live/cta-block-right-bottom.svg") right 0px bottom 0px/200px
      no-repeat,
    ${({ theme }) => theme.colors.brand[500]};

  @media ${breakpoints.tablet} {
    background: url("/assets/kelas-live/cta-block-left-top.svg") left top
        no-repeat,
      url("/assets/kelas-live/cta-block-right-bottom.svg") right bottom
        no-repeat,
      ${({ theme }) => theme.colors.brand[500]};
  }
`;

export const KelasLiveCTABlockTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  text-align: center;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.white};
  max-width: 300px;
  margin: 0 auto;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  }
`;

export const KelasLiveCTABlockButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  @media ${breakpoints.tablet} {
    gap: 16px;
  }
`;

export const KelasLiveCTABlockButton = styled.a<{
  isOutlined?: boolean;
}>`
  --webkit-appearance: none;
  background-color: ${({ theme, isOutlined }) =>
    isOutlined ? "transparent" : theme.colors.white};
  color: ${({ theme, isOutlined }) =>
    isOutlined ? theme.colors.white : theme.colors.brand["500"]} !important;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: none;
  border: ${({ theme, isOutlined }) =>
    isOutlined ? `2px solid ${theme.colors.white}` : "2px solid transparent"};
  cursor: pointer;
  max-width: 160px;
  white-space: nowrap;
  text-decoration: none;
`;

export const KelasLiveCTABlockImageWrapper = styled.figure`
  margin: 0;
  height: 100px;
  position: relative;
  @media ${breakpoints.tablet} {
    height: 250px;
  }
  @media ${breakpoints.laptop} {
    height: 300px;
  }
`;

export const KelasLiveCTABlockImage = styled.img`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
